import React, { useState } from 'react';
import { Flex, Heading, Button } from 'native-base';
import { useDashboardPageState } from '../../hooks/useDashboardPageState';
import { useFetchUserData } from '../../hooks/useFetchUserData';
import { MessageIcon } from '../../icons/MessageIcon';

export const MessageDisplay = () => {
  const {
    state: {
      user: { unread_message, id, email },
    },
  } = useDashboardPageState();

  const { updateUnreadMessage } = useFetchUserData();

  const [unreadMessage, setUnreadMessage] = useState(unread_message);

  const toggleUnreadMessage = async () => {
    const response = await updateUnreadMessage(id, !unreadMessage);
    setUnreadMessage(response.unread_message);
  };

  return (
    <Flex direction="column" px={{ base: 0, md: 2 }}>
      <Flex direction="row" alignItems={'center'} mb={6}>
        <Heading textAlign="left" pr={3}>
          Messaging
        </Heading>
      </Flex>

      <Button
        leftIcon={<MessageIcon />}
        onPress={() => {
          window.open(
            `https://app.intercom.com/a/inbox/humxgh5j/search?q=${email}`,
            '_blank'
          );
        }}
        size="xs"
      >
        Send Message
      </Button>
      <br />

      <Button size="xs" onPress={toggleUnreadMessage} id="offbtn">
        {unreadMessage ? 'Message Indicator On' : 'Message Indicator Off'}
      </Button>
    </Flex>
  );
};
